// Copyright (c) 2016 Deere & Company

import StatusChangeRequest from './components/status-change-request';
import actionCreators from '../../product/status-change-request/action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.statusChange,
    machineStatusUpdates: state.machineStatusUpdate.machineStatusUpdates
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {location, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams: location.query,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(StatusChangeRequest);



// WEBPACK FOOTER //
// ./src/product/status-change-request/state-connector.js